import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'

import axios from 'axios'
import clockImage from '@/assets/images/clock.png'

export default {
  name: 'AddDeliveryRequestSummary',
  extends: BaseModal,
  data: function () {
    return {
      blocker: false,
      clockImage: clockImage,
    }
  },
  methods: {
    createDeliveryRequest() {
      this.blocker = true
      axios({
        method: 'post',
        url: 'delivery_requests',
        data: {
          delivery_request: {
            kind: 'inbound',
            phonePrefix: this.data.phonePrefix,
            phone: this.data.phone,
            collectionPointId: this.data.collectionPoint.id,
            comment: this.data.comment,
          },
        },
      })
        .then(response => {
          this.blocker = false
          console.log('createDeliveryRequest response', response)
          window.mainApp.$emit(`updateDeliveryRequests`)
        })
        .catch(error => {
          this.$errorHumanized({ error })
          this.blocker = false
          console.error('createDeliveryRequest error', error.response)
        })
        .finally(() => {
          this.$store.commit('modal/closeAllModals')
        })
    },
  },
  components: {
    Blocker: () => import('@/vcs/_shared/blocker/cmp.vue'),
  },
}
